import { formatDate } from 'utils/date.utils';

// Constants
export const PROGRESS_COLORS = {
  OVER_LIMIT: '#117A37',
  UNDER_LIMIT: '#007CAD',
  BACKGROUND: '#C8CDD7',
};

export const PROGRESS_MAX_ANGLE = 180;
export const PROGRESS_ANGLE_MULTIPLIER = 1.8;

// Utility functions
export const calculateDaysRemaining = () => {
  const now = new Date();
  const utcYear = now.getUTCFullYear();
  const utcMonth = now.getUTCMonth();
  const utcDate = now.getUTCDate();

  const lastDayOfMonth = new Date(Date.UTC(utcYear, utcMonth + 1, 0)).getUTCDate();

  return Math.max(0, lastDayOfMonth - utcDate);
};

export const calculateUsageMetrics = (monthlyQtyUsed, monthlyUptoQty) => {
  const usagePercentage = (monthlyQtyUsed / monthlyUptoQty) * 100;
  const isOverLimit = monthlyQtyUsed > monthlyUptoQty;
  const overage = isOverLimit ? monthlyQtyUsed - monthlyUptoQty : 0;
  const progressAngle = Math.min(usagePercentage * PROGRESS_ANGLE_MULTIPLIER, PROGRESS_MAX_ANGLE);
  const progressColor = monthlyQtyUsed >= monthlyUptoQty
    ? PROGRESS_COLORS.OVER_LIMIT
    : PROGRESS_COLORS.UNDER_LIMIT;
  const reportsRemaining = Math.max(0, monthlyUptoQty - monthlyQtyUsed);

  return {
    usagePercentage,
    isOverLimit,
    overage,
    progressAngle,
    progressColor,
    reportsRemaining,
  };
};

export const formatCurrency = (value) => String(Number(value).toFixed(2));

export const reverseHistoricUsage = (historicUsage) => {
  if (!historicUsage || historicUsage?.length === 0) return [];
  return [...historicUsage].reverse();
};

export const formatDateForDisplay = (dateString) => formatDate(dateString, 'MMM D, YYYY');
